import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ErrorMessageWrapper = styled.div`
  margin-bottom: ${Spacing.S16};
`
